import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import './CTAButton.css';

interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: () => void;
  icon?: boolean;
}

export function CTAButton({
  children,
  variant = 'primary',
  href,
  onClick,
  icon = false
}: CTAButtonProps) {
  const className = `
    cta-button px-8 py-4 rounded-md font-bold transition-all transform
    text-base tracking-wide font-display antialiased
    ${variant === 'primary'
      ? 'bg-green-500 text-black hover:bg-green-400 shadow-lg shadow-green-500/20'
      : 'border-2 border-green-500 text-green-500 hover:bg-green-500/10'}
    inline-flex items-center justify-center
  `;

  const content = (
    <>
      <span className="relative z-10">{children}</span>
      {icon && <ArrowRight className="w-5 h-5 ml-2 relative z-10" />}
    </>
  );

  if (href?.startsWith('#') || href === '/book-audit') {
    return (
      <Link to="/#start-here" className={className}>
        {content}
      </Link>
    );
  }

  if (href?.startsWith('/')) {
    return (
      <Link to={href} className={className}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={className}>
        {content}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={className}>
      {content}
    </button>
  );
}